import axios from 'axios';
import { getApiBaseUrl } from '../apiConfig';
import { withPhpPriority } from '../utils/phpRequestPriority';

// Az API_BASE_URL konstans most dinamikusan jön létre
const DYNAMIC_API_BASE_URL_ROOT = getApiBaseUrl(); // Ez lesz pl. http://localhost:8000 vagy http://localhost:8080
//const API_ENDPOINT_PATH = '/api/v1/v2_spreads'; // A specifikus API elérési út
const API_ENDPOINT_PATH = '/cached_fusion_scan.php'; // A specifikus API elérési út

export const fetchFusionScans = async (type = 'back') => {
  try {
    // Az URL-t most dinamikusan állítjuk össze
    const fullApiUrl = `${DYNAMIC_API_BASE_URL_ROOT}${API_ENDPOINT_PATH}?type=${type}`;
    
    const response = await axios.get(fullApiUrl, {
      auth: {
        username: 'fusion',
        password: 'Fusion2025'
      }
    });
    
    return response.data;
  } catch (error) {
    console.error("Error fetching fusion scans (cached or direct):", error);
    if (error.response) {
      throw new Error(`Backend error: ${error.response.status} ${error.response.data.detail || error.message}`);
    } else if (error.request) {
      throw new Error('No response from server. Ensure backend is running.');
    } else {
      throw new Error(`Request setup error: ${error.message}`);
    }
  }
}; 

const API_AUTH = {
  username: 'fusion',
  password: 'Fusion2025',
};

export const fetchFusionHistorySummary = async (variant, fingerprints, current = {}) => {
  const root = getApiBaseUrl();
  const url = `${root}/fusion_history.php`;
  try {
    const response = await axios.post(
      url,
      {
        mode: 'summary',
        variant,
        fingerprints,
        current,
      },
      { auth: API_AUTH }
    );
    return response.data;
  } catch (error) {
    console.error('Error fetching fusion history summary:', error);
    if (error.response) {
      throw new Error(`Backend error: ${error.response.status} ${error.response.data?.error || error.message}`);
    }
    if (error.request) {
      throw new Error('No response from server while fetching fusion history.');
    }
    throw new Error(`Request setup error: ${error.message}`);
  }
};

export const fetchFusionHistoryDetail = async (variant, fingerprint, currentEntry = null) => {
  const root = getApiBaseUrl();
  const url = `${root}/fusion_history.php`;
  const current = currentEntry ? { [fingerprint]: currentEntry } : {};
  try {
    const response = await axios.post(
      url,
      {
        mode: 'detail',
        variant,
        fingerprint,
        current,
      },
      { auth: API_AUTH }
    );
    return response.data;
  } catch (error) {
    console.error('Error fetching fusion history detail:', error);
    if (error.response) {
      throw new Error(`Backend error: ${error.response.status} ${error.response.data?.error || error.message}`);
    }
    if (error.request) {
      throw new Error('No response from server while fetching fusion history detail.');
    }
    throw new Error(`Request setup error: ${error.message}`);
  }
};

// Generic ticker fetcher (e.g., VIX) from backend tickers table.
// Tries multiple common endpoints for compatibility.
export const fetchTicker = async (symbol) => {
  const root = getApiBaseUrl();
  const candidates = [
    `${root}/tickers.php?symbol=${encodeURIComponent(symbol)}`,
    `${root}/cached_tickers.php?symbol=${encodeURIComponent(symbol)}`,
    `${root}/ticker.php?symbol=${encodeURIComponent(symbol)}`
  ];
  for (const url of candidates) {
    try {
      const resp = await axios.get(url, {
        auth: { username: 'fusion', password: 'Fusion2025' },
      });
      return resp.data; // Expecting { symbol: 'VIX', price: number, ... }
    } catch (e) {
      // Try next candidate
      continue;
    }
  }
  throw new Error('No ticker endpoint available for symbol ' + symbol);
};

// ── GEX Cache ──
const gexCache = new Map();

export const fetchGexProfileCached = async (ticker, expiry) => {
  const cacheKey = `${ticker}_${expiry}`;
  
  if (gexCache.has(cacheKey)) {
    return gexCache.get(cacheKey);
  }

  const rootUrl = getApiBaseUrl();
  // Fetch all strikes (0 to 100000) for this expiry so we can cache it globally
  const promise = withPhpPriority(
    fetch(`${rootUrl}/gex.php?ticker=${ticker}&strike_min=0&strike_max=100000&expirations=${expiry}`)
      .then(r => {
        if (!r.ok) throw new Error(`HTTP error! status: ${r.status}`);
        return r.json();
      })
  ).catch(err => {
      gexCache.delete(cacheKey); // Remove failed promise from cache
      throw err;
    });

  gexCache.set(cacheKey, promise);
  return promise;
};